module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('apartment-blank-form', {
    attrs: {
      "submit-label": "Добавить квартиру",
      "apartment": _vm.apartment,
      "errors": _vm.errors,
      "form-type": "add"
    },
    on: {
      "submit": _vm.processApartmentForm
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-60b38ad2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/apartment/ApartmentAddForm.vue
// module id = 654
// module chunks = 0